import React from "react";

const Whatsapp = () => {
    return (
        <>
            <a href="https://api.whatsapp.com/send?phone=918057979202" rel="noreferrer" className="float" target="_blank">
                <i className="fab fa-whatsapp  inverted"></i>
            </a>
        </>
    );
};

export default Whatsapp;
